import $axios from '@/service/httpServer'

export const corrupReport=params=>$axios.post(`/pdp/xcx/feedback/inform`, params); //廉政举报

export const corrupReportInfo=params=>$axios.get(`/pdp/xcx/feedback/detail`, params); //廉政举报详情

export const complainSuggest=params=>$axios.post(`/pdp/xcx/feedback/submit`, params); //意见反馈





